/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_2Inputs */

const da_privacy_retention_2 = /** @type {(inputs: Privacy_Retention_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøver, elevbesvarelser og AI-resultater: slettes automatisk 12 måneder efter, du sidst har brugt prøven. Du får påmindelser på e-mail først. En prøve, du selv sletter, fjernes endeligt efter 30 dage.`)
};

/** @type {(inputs: Privacy_Retention_2Inputs) => LocalizedString} */
const en_privacy_retention_2 = da_privacy_retention_2;

/**

* @param {Privacy_Retention_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_2 = /** @type {((inputs?: Privacy_Retention_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_2(inputs)
	return /** @type {LocalizedString} */ ("Prøver, elevbesvarelser og AI-resultater: slettes automatisk 12 måneder efter, du sidst har brugt prøven. Du får påmindelser på e-mail først. En prøve, du selv sletter, fjernes endeligt efter 30 dage.")
});